module.exports = __webpack_public_path__ + "img/apple-app-store_ko_equalised.3f601404.svg";